import { useAppSelector } from '@src/core/hooks';
import { buyerSelector } from '@src/features/customers';

import { useCheckoutNavigation } from '../CheckoutFlowContext';
import { canManageCheckoutCoupon } from '../core/canManageCheckoutCoupon';

export const useCheckoutCouponManageability = (canManageCartCoupon: boolean) => {
  const { mode } = useCheckoutNavigation();
  const [, logged] = useAppSelector(buyerSelector);

  return canManageCheckoutCoupon(mode, canManageCartCoupon, Boolean(logged));
};

export default useCheckoutCouponManageability;
